/**
 * @deprecated Use AiService.GetModelByName() instead
 * Legacy enum kept for backward compatibility
 */
export enum AIModel {
	'o1-preview' = 'o1-preview',
	'gpt-4o' = 'gpt-4o',
	'gpt-4.1' = 'gpt-4.1',
	'gpt-4.1-nano' = 'gpt-4.1-nano',
	'gpt-5' = 'gpt-5',
	'claude-3-5-sonnet-20241022' = 'claude-3-5-sonnet-20241022',
	'claude-3-7-sonnet-20250219' = 'claude-3-7-sonnet-20250219',
}
